module.exports = __webpack_public_path__ + "static/media/camera-movie.684aa503.svg";